import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { StandingItem } from '../../../../models/standing.model';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { SportsService } from '../../../../services/sport.service';
import { GenericService } from '../../../../services/generic.services';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzTableComponent, NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-standings-sports',
  standalone: true,
  imports: [
    NzTableModule,
    NzToolTipModule,
    TranslateModule,
    CommonModule,
    TranslateModule,
    NzGridModule,
    NzSkeletonComponent,
    NzTableComponent,
    RouterLink,
  ],
  templateUrl: './standings-sports.component.html',
  styleUrl: './standings-sports.component.scss',
})
export class StandingsSportsComponent {
  standingArray: any = [];
  filterSelected: any = 'All';
  loader = true;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  today: any = '';

  listOfColumn = [
    {
      title: '#',
      compare: (a: StandingItem, b: StandingItem) => a.position - b.position,
      priority: 1,
      show: true,
      tooltip: this.translateService.instant('Position'),
      fixed: true,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('Team'),
      compare: (a: StandingItem, b: StandingItem) =>
        a.nameTeam.localeCompare(b.nameTeam),
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Team'),
      fixed: true,
      width: '80px',
      align: 0,
    },
    {
      title: this.translateService.instant('GP'),
      compare: (a: StandingItem, b: StandingItem) => a.total - b.total,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Matches'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('W'),
      compare: (a: StandingItem, b: StandingItem) => a.won - b.won,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Win'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('L'),
      compare: (a: StandingItem, b: StandingItem) => a.loss - b.loss,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Loss'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('S'),
      compare: (a: StandingItem, b: StandingItem) => a.scored - b.scored,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Scored'),
      fixed: false,
      width: '20px',
      align: 2,
    },
    {
      title: this.translateService.instant('PTS'),
      compare: (a: StandingItem, b: StandingItem) => a.points - b.points,
      priority: 2,
      show: true,
      tooltip: this.translateService.instant('Points'),
      fixed: false,
      width: '30px',
      align: 2,
    },
  ];

  @Input() idCompetition = '';

  constructor(
    private scoresServices: ScoresSportsService,
    public utilityService: UtilitiesService,
    private readonly translateService: TranslateService,
    private _activateRoute: ActivatedRoute,
    public menuService: SportsService,
    private genericServices: GenericService
  ) {}

  ngOnInit(): void {
    this.today = this.genericServices.getCurrentDate();
    // moment()
    //   .format('YYYY')
    //   .toString()
    //   .concat(
    //     moment().format('MM').toString(),
    //     moment().format('DD').toString()
    //   );
    this.loadStandingCompetition();
  }

  ngOnChanges(): void {
    this.today = this.genericServices.getCurrentDate();
    // moment()
    //   .format('YYYY')
    //   .toString()
    //   .concat(
    //     moment().format('MM').toString(),
    //     moment().format('DD').toString()
    //   );
    this.loader = true;
    this.loadStandingCompetition();
  }

  loadStandingCompetition(): void {
    this.standingArray = [];
    this.scoresServices.getStandingsCompetition(this.idCompetition).subscribe(
      (result: any) => {
        if (result.status) {
          this.standingArray = result.data?.map((item: any) => ({
            color: 'red',
            draw: 5,
            scored: item.scored ? item.scored : item.pointsWon,
            logoTeam: item.team.logo || this.urlIMG + 'default.png',
            position: item.position,
            team_id: item.team.id,
            nameTeam: item.team.name || 'NA',
            total: item.played,
            won: item.won,
            loss: item.lost,
            points: item.points,
          }))

          // this.standingArray = result.data?.map((item: any) => {
          // return {
          //           color: 'red',
          //           draw: 5,
          //           scored: item.scored ? item.scored : item.pointsWon,
          //           logoTeam: item.team.logo || this.urlIMG + 'default.png',
          //           position: item.position,
          //           team_id: item.team.id,
          //           nameTeam: item.team.name || 'NA',
          //           total: item.played,
          //           won: item.won,
          //           loss: item.lost,
          //           points: item.points,
          // };
          // });
          this.loader = false;
        } else this.loader = false;
      },
      () => {
        this.loader = false;
      }
    );
  }
}
